import { urls } from '@/urls';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { ActionCenterItemV2 } from '@cloudcost/shared-types/action-center-v2';

export type ActionCenterModule = 'Attestation' | 'Allocation' | 'Budgets' | 'Optimization';

const MODULE_TO_ENDPOINT: Record<ActionCenterModule, string> = {
  Attestation: urls.DevOps.getAttestationActionCenterV2,
  Allocation: urls.DevOps.getAllocationActionCenterV2,
  Budgets: urls.DevOps.getBudgetActionCenterV2,
  Optimization: urls.DevOps.getOptimizationActionCenterV2,
};

/**
 * Fetches Action Center V2 list for a module and returns the item with matching id (if found).
 * If items array is provided, searches through it instead of fetching.
 */
export async function fetchActionCenterItemV2(
  module: ActionCenterModule,
  id: string | number,
  items?: ActionCenterItemV2[],
): Promise<ActionCenterItemV2 | undefined> {
  // If items are provided, search through them instead of fetching
  if (items && Array.isArray(items)) {
    return items.find((it) => String(it.id) === String(id));
  }

  // Otherwise, fetch the list
  const endpoint = MODULE_TO_ENDPOINT[module];
  if (!endpoint) return undefined;
  const list = await fetchWrapper.get(endpoint);
  if (!Array.isArray(list)) return undefined;
  return (list as ActionCenterItemV2[]).find(
    (it) => String(it.id) === String(id),
  );
}
